<template>
  <div class="Tabs">
    <b-tabs card>

          <b-tab :title="lang.tab_Parts" :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row-max">
              <b-row>
                  <b-col  cols="1"><p>{{lang.infotext_1}}:</p></b-col>
                  <b-col  cols="3"><ComboboxComponent class="ComboboxComponent" :lang="lang.Filters"></ComboboxComponent></b-col>
                  <b-col  cols="8"><FiltersComponent class="FiltersComponent" :lang="lang.FiltersButtons"></FiltersComponent></b-col>
              </b-row>
              <b-row>
                <b-col><hr class="hr"></b-col><br>
              </b-row>
              <b-row v-if="isPlugin">
                <b-col></b-col>

              </b-row>
              
            </b-container>
            <!-- <div v-if="isPlugin">
              <b-container class="bv-example-row-max">
              <b-row>
                  <b-col  cols="1"><p>{{lang.infotext_2}}:</p></b-col>
                  <b-col  cols="4"><CategoryComponent  :lang="lang.PluginCategory"></CategoryComponent></b-col>
                  
              </b-row>
              </b-container>
            </div> -->
            <DataTableFilteredOnApiLibComponent :lang="lang.LibraryTable"></DataTableFilteredOnApiLibComponent>

          </b-tab>

    </b-tabs>






  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DataTableFilteredOnApiLibComponent from "@/components/shared/DataTableFilteredOnApiLibComponent"
import ComboboxComponent from "@/components/shared/ComboboxComponent"//@/components/LibraryManager/Views/LibraryTable/Middle/Content/ComboboxComponent"
import FiltersComponent from "@/components/shared/FiltersComponent"
import CategoryComponent from "@/components/shared/CategoryComponent"



export default {
  name: "Content",
  components: {
    DataTableFilteredOnApiLibComponent,
    ComboboxComponent,
    FiltersComponent,
    CategoryComponent

  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {
      data: {},

      dataCombobox: {title: "Filter list"},


    }
  },
  computed: {
    ...mapGetters({

      isPlugin: "isPlugin"

    }),
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {

  },
  updated() {

  },
  watch: {

  }
}
</script>

<style lang="scss">

  .Tabs{
    .ComboboxComponent{
      margin-left: 10px;
    }


    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

    .row{
      margin-right: 0px;
      margin-left: 0px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryTable/Middle/Content/Content.vue